//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.ComparisonResultBase.js";
let d=[[[0,"EcadProjectId",0,0],[0,"PartName",0,0]],[[[],"Dispose",{},0,0],[["numResults","results"],"GetResults",{},0,0],[["conflictResult","action","numReplacements","replacements"],"ResolveConflictResult",{},2,0]],[]];
SPLM.Mechatronics.ComparisonResultContext = class extends SPLM.Mechatronics.ComparisonResultBase{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ComparisonResultContext";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ComparisonResultContext.ResolveConflictAction = Object.freeze({
    "Ignore" : "Ignore", "Create" : "Create", "Update" : "Update"});

export default SPLM;